import React, { useContext, useEffect, useState } from 'react'
import { ConfigContext } from '../../../Context/ConfigContext';
import axios from 'axios';
import { axiosGet } from '../../../Apis/axiosMethods';

const SimilarCharacteristics = ({ ART_ID, STR_ID, part }) => {


    const { currency, apiB2BURL, popular_models, apiHeaderJson } = useContext(ConfigContext);

    const [parts, setParts] = useState([]);

    const GetParts = async (oe_number) => {
        try {
            const response = await axiosGet(`/Parts/GetMergeCrossFitParts`, {
                oe_number: oe_number,
                art_id: ART_ID,
                lang: "en",
                currency: currency,
                limit: 50,
                page: 1
            });

            if (response?.data?.success) {
                setParts(response.data.data);
            }
        } catch (error) {
            console.error("Fetch error:", error);
        }
    };


    useEffect(() => {
        if (!part?.OEM_NUMBERS) return;

        const firstLine = part.OEM_NUMBERS.split("\n")[0];

        const oemNumber = firstLine.split(":")[1]?.trim();

        if (oemNumber) {
            GetParts(oemNumber);
        }
    }, [part]);

    const filteredParts = parts.filter(
        item => item.ART_SEARCH_NUMBER !== part?.ART_SEARCH_NUMBER
    );

    const GetPriceRange = () => {
        const prices = parts
            .map(p => p.VD_BB_PRICE)
            .filter(price => price != null && !isNaN(price));

        if (prices.length === 0) return "No prices available";

        const minPrice = Math.min(...prices);
        const maxPrice = Math.max(...prices);

        return `${minPrice.toFixed(2)} - ${maxPrice.toFixed(2)} AED`;
    }

    // const GetBrandList = () => {
    //     return parts &&
    //         [...parts]
    //             .filter((value, index, self) =>
    //                 index === self.findIndex((t) => (
    //                     t.ART_SUP_BRAND === value.ART_SUP_BRAND
    //                 ))
    //             )
    //             .map((img, index) => {
    //                 // add comma
    //                 return img.ART_SUP_BRAND.trim() + (index < parts.length - 1 ? ', ' : '');
    //             })
    // }


    const GetBrandList = () => {
        const filteredBrands = [...parts]
            // 👇 current brand remove
            .filter(item =>
                item.ART_SUP_BRAND?.trim() !== part?.stock_brand_name?.trim()
            )
            // 👇 remove duplicates
            .filter((value, index, self) =>
                index === self.findIndex(
                    (t) => t.ART_SUP_BRAND === value.ART_SUP_BRAND
                )
            );

        return filteredBrands.map((img, index) => {
            return (
                img.ART_SUP_BRAND.trim() +
                (index < filteredBrands.length - 1 ? ', ' : '')
            );
        });
    }


    const GetCarMakes = () => {
        var allOEMS = [];

        for (var i = 0; i < parts.length; i++) {

            if (
                parts[i].OE_NUMBERS_CROSS !== 'null' &&
                parts[i].OE_NUMBERS_CROSS !== null &&
                parts[i].OE_NUMBERS_CROSS !== undefined
            ) {

                for (var j = 0; j < parts[i].OE_NUMBERS_CROSS.length; j++) {
                    // 👇 current brand skip
                    if (
                        parts[i].OE_NUMBERS_CROSS[j].ARL_BRA_BRAND?.trim() ===
                        part?.stock_brand_name?.trim()
                    ) {
                        continue;
                    }

                    allOEMS.push(parts[i].OE_NUMBERS_CROSS[j].ARL_BRA_BRAND);
                }
            }
        }

        // remove duplicates
        var uniqueOEMs = [...new Set(allOEMS)];

        uniqueOEMs = uniqueOEMs.map((img, index) => {
            return img.trim() + (index < uniqueOEMs.length - 1 ? ', ' : '');
        });

        return uniqueOEMs;
    }


    const GetOEMNumbers = () => {
        var allOEMS = [];

        for (var i = 0; i < parts.length; i++) {
            if (parts[i].OE_NUMBERS_CROSS !== 'null' && parts[i].OE_NUMBERS_CROSS !== null && parts[i].OE_NUMBERS_CROSS !== undefined) {
                for (var j = 0; j < parts[i].OE_NUMBERS_CROSS.length; j++) {
                    allOEMS.push(parts[i].OE_NUMBERS_CROSS[j].ARL_SEARCH_NUMBER);
                }
            }
        }

        var uniqueOEMs = [...new Set(allOEMS)];
        uniqueOEMs = uniqueOEMs.map((img, index) => {
            // add comma
            return img.trim() + (index < uniqueOEMs.length - 1 ? ', ' : '');
        });
        return uniqueOEMs;
    }


    const [showAllModels, setShowAllModels] = useState(false);

    return (
        <>
            {
                filteredParts?.length > 0 &&
                <>
                    <div className="container mt-3">
                        <h4>{part?.ART_PRODUCT_NAME} {part?.stock_brand_name} {part?.ART_SEARCH_NUMBER} : compatible with the following popular cars</h4>

                        <div className="row">
                            <table className="table table-bordered">
                                <tr className='col-md-12 text-center'>
                                    <td className='col-md-6'>OEM Brand</td>
                                    <td className='col-md-6'>{parts && GetBrandList()}</td>
                                </tr>
                                <tr className='col-md-12 text-center'>
                                    <td className='col-md-6'>Car Make</td>
                                    <td className='col-md-6'>{parts && GetCarMakes()}</td>
                                </tr>
                                <tr className='col-md-12 text-center'>
                                    <td className='col-md-6'>Year of manufacture</td>
                                    <td className='col-md-6'>{part?.PC_CI_FROM}-{part?.PC_CI_TO}</td>
                                </tr>
                                <tr className='col-md-12 text-center'>
                                    <td className='col-md-6'>Manufacturer article number</td>
                                    <td className='col-md-6'>{part?.ART_SEARCH_NUMBER}</td>
                                </tr>
                                <tr className='col-md-12 text-center'>
                                    <td className='col-md-6'>OEM {part?.ART_SEARCH_NUMBER} Equivalents</td>
                                    <td className='col-md-6'>{parts && GetOEMNumbers()}</td>
                                </tr>
                            </table>
                        </div>

                    </div>
                    {
                        parts?.length > 0 &&
                        <div className='container mt-3 mb-3'>
                            <h4>{part?.stock_brand_name} {part?.ART_SEARCH_NUMBER} : spare parts with similar characteristics</h4>

                            <div className="row">
                                {
                                    parts?.map(item => {
                                        if (item.ART_SEARCH_NUMBER === part.ART_SEARCH_NUMBER) return null;
                                        return (
                                            <div className="col-md-6 border p-3">
                                                <div className='d-flex align-items-center justify-content-around'>
                                                    <span style={{ fontWeight: "600" }}>{item?.stock_brand_name}</span>
                                                    <span style={{ fontWeight: "600" }}>{item?.ART_SEARCH_NUMBER}</span>
                                                </div>
                                            </div>
                                        )
                                    })
                                }
                            </div>

                        </div>
                    }

                </>
            }

            {
                popular_models?.length > 0 &&
                <div className='container mt-3'>

                    <h4>
                        {part?.PRODUCT_GROUP_EN} {part?.stock_brand_name}{" "}
                        {part?.ART_SEARCH_NUMBER} is suitable for the following popular car models
                    </h4>

                    <div className="row">
                        {
                            (showAllModels
                                ? popular_models
                                : popular_models.slice(0, 12)
                            )?.map((item, index) => {

                                if (item.ART_SEARCH_NUMBER === part.ART_SEARCH_NUMBER) {
                                    return null;
                                }

                                return (
                                    <div className="col-md-3 mb-1" key={index}>
                                        <span className='text-primary'>
                                            {item}
                                        </span>
                                    </div>
                                );
                            })
                        }
                    </div>

                    {
                        popular_models.length > 12 && (
                            <div className="text-center mt-3">
                                {
                                    !showAllModels ? (
                                        <span
                                            className="btn-link"
                                            style={{
                                                cursor: "pointer",
                                                fontWeight: "600"
                                            }}
                                            onClick={() => setShowAllModels(true)}
                                        >
                                            Show More
                                        </span>
                                    ) : (
                                        <span
                                            className="btn-link"
                                            style={{
                                                cursor: "pointer",
                                                fontWeight: "600"
                                            }}
                                            onClick={() => setShowAllModels(false)}
                                        >
                                            Show Less
                                        </span>
                                    )
                                }
                            </div>
                        )
                    }

                </div>
            }


        </>
    )
}

export default SimilarCharacteristics
